import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Tooltip } from "reactstrap";
import { FILTER_LABELS, PAGE_SPECIFIC_LABELS } from "../../constants/filterLabels";

const LOCKED_FILTERS = new Set(['Filtro_Data_Inicio', 'Filtro_Data_Termino', 'Filtro_Data_Fim']);

const PreFilterBadge = ({ label, value, index, field, callback = () => {} }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const { pathname } = useLocation();

  const isLocked = LOCKED_FILTERS.has(label);

  const displayLabel = useMemo(() => {
    if (label === "Filtro_Numero_Documento") {
      const activePage = Object.keys(PAGE_SPECIFIC_LABELS).find(page => pathname.includes(page));
      return PAGE_SPECIFIC_LABELS[activePage] ?? "Número Documento: ";
    }
    return FILTER_LABELS[label] ?? label;
  }, [label, pathname]);

  const elementId = `badge_${field?.replace(/\s/g, "_").toLowerCase()}_${index}`;

  return (
    <>
      <button
        id={elementId}
        onClick={!isLocked ? () => callback(index) : undefined}
        className="badge-filter-applied-dynamic btn btn-light-blue-08 text-color-azul1 font-size-12 px-3 font-w-400 rounded-pill d-flex align-items-center gap-3"
      >
        {displayLabel}
        {value?.length > 20 ? `${value.substring(0, 20)}...` : value}
        {!isLocked && <i className="fas fa-times"></i>}
      </button>

      <Tooltip
        isOpen={isTooltipOpen}
        target={elementId}
        toggle={() => setIsTooltipOpen(prev => !prev)}
      >
        {field} - {value}
      </Tooltip>
    </>
  );
};

export default PreFilterBadge;